import React from 'react';
import AppWrapper from '../../app-wrapper';
import Articles from '../../components/articles';
import ViewHeader from '../../components/view-header';
import Accordion from '../../components/accordion/accordion';
import BarGraphStacked from '../../components/bar-graph-stacked';
import BusinessCasesList from '../../components/business-cases-list';
import GenericCard from '../../components/generic-card';
import CallToAction from '../../components/call-to-action';
import { readmore, ReadMoreContext } from '../../components/read-more-text/readMoreContext';
import { ROUTE_PATHS } from '../../app-constants';

const DashBoard = (props) => {
  const {
    articles = {},
    marketComparison = [],
    authorableContent,
    graphAuthorableContent,
    totalBenefits,
    imageBaseLink,
    bcbCasesList,
  } = props;
  const { viewContentHeader, accordions, businessCasesWidget } = authorableContent;
  const { trendingArticleTitle, latestArticleTitle } = accordions;
  const { trendingArticles = [], latestArticles = [] } = articles;
  if (trendingArticles.length > 0 || latestArticles.length > 0) {
    const sidebarContent = bcbCasesList.length
      ? <BusinessCasesList isWidget />
      : <p className="my-3 font-weight-bold">{businessCasesWidget.hasNoBusinessCasesText}</p>;

    const SidebarFooter = () => {
      const hasBusinessCases = bcbCasesList.length ? 'hasBusinessCasesCTA' : 'hasNoBusinessCasesCTA';
      return (<CallToAction
        buttonText={businessCasesWidget[hasBusinessCases]}
        route={bcbCasesList.length ? ROUTE_PATHS.myBusinessCases.route : ROUTE_PATHS.marketComparison.route}
        buttonId="buttonHasBusinessCases"
        customClasses="clear"
        alignment="center"
        hasPaddingBox={false}
      />);
    };

    return (
      <AppWrapper>
        <div className="homepage root-container container">
          <ViewHeader content={viewContentHeader} />
          <div className="graph-usage row">
            <div className="col-sm-8 main-with-sidebar block-spacer">
              <BarGraphStacked
                authorableContent={graphAuthorableContent}
                data={marketComparison}
                totalBenefits={totalBenefits}
                showMarketComparisonLink
                hideYAxisTooltip
              />
            </div>
            <div className="col-sm-4 sidebar sidebar-with-cta sidebar block-spacer">
              <div className="row d-flex flex-column">
                <GenericCard
                  headerTitle={businessCasesWidget.heading}
                  headerDescription={businessCasesWidget.description}
                  cardClass={`${!bcbCasesList.length ? 'has-no-business-cases' : ''}`}
                  contentComponent={sidebarContent}
                />
              </div>
              <SidebarFooter />
            </div>
          </div>
          <div className="row d-flex flex-column">
            {trendingArticles.length > 0 &&
              <Accordion
                title={trendingArticleTitle}
                accordionWrapperClass="card-body block-spacer article-accordion"
              >
                <ReadMoreContext.Provider value={readmore.doNotUseModal}>
                  <Articles articles={trendingArticles} imageBaseLink={imageBaseLink} />
                </ReadMoreContext.Provider>
              </Accordion>
            }
            {latestArticles.length > 0 &&
              <Accordion
                title={latestArticleTitle}
                accordionWrapperClass="card-body block-spacer article-accordion last-block-spacer"
              >
                <ReadMoreContext.Provider value={readmore.doNotUseModal}>
                  <Articles articles={latestArticles} imageBaseLink={imageBaseLink} />
                </ReadMoreContext.Provider>
              </Accordion>
            }
          </div>
        </div>
      </AppWrapper>
    );
  }
  return <h1 className="text-center">loading..</h1>;
};

export default DashBoard;
